const Biography = () => (
  <div className="flex flex-col">
    <div className="my-8">
      <h1 className="text-center ">Biografia e Historia del Autor</h1>
    </div>
    <div className="my-8 px-12 sm:px-56">
      <p>
        Nací en Guadalajara, Jalisco un día 18 de Marzo de 1934 en la calle de
        Juan Álvarez 818 Barrio de la Capilla de Jesús, hijo de Enrique
        Gutiérrez Álvarez y Amparo Torres Torres, mis hermanos Enrique, María de
        la Luz, Francisco Javier, Gustavo, Dolores Raulina, Germán, nacidos los
        3 primeros en_ el estado de Nuevo México (USA) y los 4 últimos en
        Guadalajara; Dado que nuestros padres emigraron al norte por el año de'
        1923 a la casa de una hermana de nuestra madre que vivía en Ratón Nuevo
        México, ahí mis padres trabajaron en el campo y mi padre posteriormente
        en una mina de carbón.
      </p>
      <p>
        Por los años 30 mis padres regresaron a Guadalajara en dónde en 1934
        nací y en ese año mis papás compraron la finca de Juan Álvarez 833 dónde
        empezaron a trabajar con unas máquinas manuales para hacer medias y
        calcetines compradas con dinero de una casa propiedad de mi madre que
        vendió para esas compras, dando inicio a una empresa de las primeras en
        Guadalajara de fabricación de medias y calcetines que se llamó
        'Centenario y Ega'.
      </p>
      <p>
        La vida empezó a fluir en mi con alegrías, tristezas y mucho dolor ya
        que a los 6 años de edad la muerte me arrebató a mi madre cuando sentada
        en la banqueta fuera de la casa de mi tía Esperanza, un automóvil
        manejado por un irresponsable se subió a la banqueta y mató a mi madre.
      </p>
      <p>
        Con esa carga tan pesada para mi crecí con el dolor y la tristeza de no
        contar con la única mujer que verdaderamente nos ama y nos protege de
        los males que nos acechan día a día. Estudié la primaria, secundaria y
        preparatoria en el Colegio Cervantes (Centro y Munguía 90) pasando a la
        facultad de derecho de la Universidad de Guadalajara, que en esa época
        se ubicaba en el Paraninfo de dicha Universidad, ahí estudie la carrera
        de Abogado o Derecho.
      </p>
      <p>
        Mis ascendientes por parte de mi padre fueron el Sr. Germán Gutiérrez
        Vázquez o Oriundo de un rancho de Arandas Jalisco, mi abuela Rosa
        Álvarez Gonzáléz Rubio de Guadalajara, mi mamá era hija de Fermín Torres
        y Josefa Torres nacidos también en Guadalajara.
      </p>
      <p>
        Fueron estos y otros acontecimientos como el asesinato de mi abuelo
        paterno a quien asaltaron por el año de 1912 en los cerros de Sayula,
        Jalisco. Por ladrones que le robaron su mercancía de telas, vestidos,
        etc. Que vendía en esos rumbos y los trasportaba en caballos y mulas en
        ese acontecimiento dejaron gravemente herido a mi papá con las puñaladas
        que le dieron siendo apenas un niño de 8 años edad.
      </p>
      <p>
        Todos estos acontecimientos vividos por mí y otros relatados por mi
        familia me motivaron a escribir lo que aquí publicó y que con cariño y
        humildad dejo como un legado a mi esposa María, a mis hijos lvári
        Efraín, Jorge Edgardo y Rolando y nietos Susana Estefanía, lván,
        Edgardo, Rodrigo y Evan para que comprendan en pocas líneas el pasado
        del que esto escribe ...
      </p>
    </div>
  </div>
);

export default Biography;
